// @ts-nocheck

import { StatisticType } from './statisticTypeEnum';

export type Param1 = 'data_change' | 'odds_click' | 'social_share' | 'license_error';

export type BetRadarParam2 = {
  solution: string;
  component: string;
  language: string;
  customer: string;
  brand: string;
  sportId: string;
  categoryId: string;
  uniqueTournamentId: string;
  tournamentId: string;
  seasonId: string;
  matchId: string;
  stageId: string;
  error: 'UnsupportedSportError' | string;
  build: string;
  matchStatus: string;
};

export interface BetRadarProps {
  type: StatisticType;
  className: string;
  settings: {
    [key: string]: unknown;
    // eslint-disable-next-line no-unused-vars
    onTrack: (param?: Param1, param2?: BetRadarParam2) => void;
  };
}

export const betRadar = ({ type, settings, className }: BetRadarProps) => {
  // console.log(`SIR('addWidget', "${className}", "${type}", ${JSON.stringify(settings)})`);
  if (!SIR) throw new Error('SIR is not defined - be sure to import betRadar script first');
  return SIR('addWidget', className, type, settings);
};

export const betRadarDestroy = (className: string) => {
  if (!SIR) throw new Error('SIR is not defined - be sure to import betRadar script first');

  // console.log(`SIR('removeWidget', "${className}")`);
  return SIR('removeWidget', className);
};
